/* eslint-disable @typescript-eslint/no-unused-vars */

import { Typography, useTheme } from '@mui/material';
import { type GridColumns, type GridValidRowModel } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { Fragment, useState } from 'react';
import { colorTheme } from '../../../../theme';
import { CustomDataGrid } from 'components';
import { type IEmployeeProps } from 'types';

type GridRowData = Record<string, unknown>;

const NotOnboardEmployees = (): JSX.Element => {
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);
  const [employeeData, setEmployeeData] = useState<IEmployeeProps[]>([]);

  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'firstName',
      flex: 0.5,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          First name
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.firstName} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.firstName} */}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'lastName',
      flex: 0.5,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          Last name
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.lastName} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.lastName} */}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'email',
      flex: 0.7,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          Email address
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.email} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.email} */}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'phone',
      flex: 0.5,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          Phone number
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row.phone} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.phone} */}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'employerContribution',
      flex: 0.5,
      headerName: 'Employer contribution',

      renderCell: ({ row }) => (
        <Tooltip title={row.employerContribution} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.employerContribution} */}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'employeeContribution',
      flex: 0.5,
      headerName: 'Employee contribution',
      renderCell: ({ row }) => (
        <Tooltip title={row.employeeContribution} placement="top">
          <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
            {/* {row.employeeContribution} */}
          </Typography>
        </Tooltip>
      ),
    },
  ];

  return (
    <Fragment>
      <CustomDataGrid
        // title="Employee"
        columns={columns}
        rows={employeeData as GridRowData[]}
        getRowId={(row: IEmployeeProps) =>
          `${String(row.empId)}${row.email ? row.email : ''}`
        }
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        currentPage="employees"
      />
    </Fragment>
  );
};

export default NotOnboardEmployees;
